// 209 §7 [RULED 16] — A SENTENCE WHOSE WORDS AGREE WITH ONE OF ITS NUMBERS.
//
// The resolver picks a plural form by `vars.count` (src/lib/i18nResolve.ts —
// the language's own rule, ruling 16); a seeded sentence prints its number under
// its own placeholder (« {n} ignorés », « {auto} minutes », « {on} / {total}
// délégables »). So the caller hands the number twice: under its name, and as
// `count`. Written once here, the number is READ once at the call site — a
// screen's numbers are often untyped (`any`), and a second read of the same
// expression was a second unsafe read.

/**
 * The vars for `t(key, …)`: `vars`, with `value` under `name` and — when it is a
 * number — as `count`, the one the plural form is chosen by. Takes `unknown`:
 * it is the seam where a screen's untyped numbers are read.
 */
export function withCount(value: unknown, name: string, vars: Record<string, unknown> = {}): Record<string, unknown> {
  const n = typeof value === "number" ? value : Number(value);
  return { ...vars, [name]: value, ...(Number.isFinite(n) ? { count: n } : {}) };
}
